var AppointmentCommunicationChannel = /* @__PURE__ */ ((AppointmentCommunicationChannel2) => {
  AppointmentCommunicationChannel2["EMAIL"] = "EMAIL";
  AppointmentCommunicationChannel2["SMS"] = "SMS";
  return AppointmentCommunicationChannel2;
})(AppointmentCommunicationChannel || {});
export {
  AppointmentCommunicationChannel
};
//# sourceMappingURL=shared.js.map
